import {
  formatInvitationPairingCode,
  invitationPairingCodeSchema,
} from "@msys/common";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { MeisterMark } from "../../auth/signup/MeisterMark.js";
import { ONBOARDING_BODY_SX } from "../../features/organisations/onboarding/onboardingDesign.js";
import { InvitationHeading } from "../InvitationHeading.js";
import { InvitationPage } from "../InvitationPage.js";
import { PairingCodeCard } from "./PairingCodeCard.js";
import { rememberPairingCode } from "./rememberedPairingCode.js";

export const ContinueInvitationJoinPage = () => {
  const { t } = useTranslate(["Global"]);
  const [searchParams] = useSearchParams();
  const parsed = invitationPairingCodeSchema.safeParse(
    searchParams.get("code") ?? ""
  );
  const code = parsed.success ? parsed.data : null;

  // Remembering is an idempotent write, redone for every code the URL carries,
  // so the copy below never claims a save that blocked storage refused.
  const isRemembered = React.useMemo(
    () => (code ? rememberPairingCode(code) : false),
    [code]
  );

  const codeDisplay = code ? (
    <Box sx={{ mt: "28px" }}>
      <PairingCodeCard code={formatInvitationPairingCode(code)} />
    </Box>
  ) : null;

  const body = (text: string) => (
    <Typography sx={{ ...ONBOARDING_BODY_SX, mt: "11px", width: "100%" }}>
      {text}
    </Typography>
  );

  return (
    <InvitationPage isAuthenticated={false}>
      <Stack sx={{ alignItems: "center" }}>
        <MeisterMark />
        {code && !isRemembered ? (
          <>
            <Typography
              sx={{ ...ONBOARDING_BODY_SX, mt: "25px", width: "100%" }}
            >
              {t(
                "Open the invitation link from your email on your phone, choose “Continue on another device” and enter this code:",
                { ns: "Global" }
              )}
            </Typography>
            <Box sx={{ width: "100%" }}>{codeDisplay}</Box>
          </>
        ) : code ? (
          <>
            <InvitationHeading sx={{ mt: "25px" }}>
              {t("Code saved", { ns: "Global" })}
            </InvitationHeading>
            <Box sx={{ width: "100%" }}>{codeDisplay}</Box>
            {body(
              t(
                "Now open the invitation link from your email on this phone. The code will be filled in for you.",
                { ns: "Global" }
              )
            )}
          </>
        ) : (
          <Typography
            color="error"
            sx={{ mt: "25px", lineHeight: "24px", textAlign: "center" }}
          >
            {t(
              "This QR code is invalid. Please enter the code shown on the other device on your invitation page.",
              { ns: "Global" }
            )}
          </Typography>
        )}
      </Stack>
    </InvitationPage>
  );
};
